import React from 'react';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';

import CompanyLinkInline from './CompanyLinkInline';

const CompanyLinkModal = ({
  visible,
  onHide,
  configId
}) => {
  const footerContent = (
    <div className="flex gap-2">
      <Button label="Fechar" icon="pi pi-times" onClick={onHide} />
    </div>
  );

  return (
    <>
      <Dialog
        header={`Vincular Empresa - Layout`}
        visible={visible}
        onHide={onHide}
        modal
        style={{ width: '90vw', maxWidth: '800px' }}
        footer={footerContent}
      >
        <CompanyLinkInline configId={configId} itensLayout={() => {}} />
      </Dialog>
    </>
  );
};

export default CompanyLinkModal;

